import uaeDirham from '../assets/currency/uae_dirham'
import sarRiyal from '../assets/currency/sar_riyal'

export default (ctx, inject) => {
	const getCurrencySymbol = () => {
		const formatter = new Intl.NumberFormat(
			ctx.store.state.locale, {
				style: 'currency',
				currency: ctx.store.state.merchant.currencyCode
			}
		).formatToParts(0)

		return formatter.find(p => p.type === 'currency')?.value || ''
	}

	const currencySymbol = (color = 'white', size) => {
		const formatter = new Intl.NumberFormat(
			ctx.store.state.locale, {
				style: 'currency',
				currency: ctx.store.state.merchant.currencyCode
			}
		).formatToParts(0)

		if (ctx.store.state.merchant.currencyCode === 'AED' && ctx.store.state.merchant.customAttributes.currency_symbol !== 'AED') {
			return uaeDirham(color, size)
		} else if (ctx.store.state.merchant.currencyCode === 'SAR' && ctx.store.state.merchant.customAttributes.currency_symbol !== 'SAR') {
			return sarRiyal(color, size)
		}

		return formatter.find(p => p.type === 'currency')?.value || ''
	}

	const toCurrencyString = (price, currencyCode) => {
		let currency = ctx.i18n.n(
			price,
			{
				style: 'currency',
				currency: currencyCode || ctx.store.state.merchant.currencyCode,
				locale: ctx.store.state.locale
			}
		)

		const intlCurrency = getCurrencySymbol()

		if (intlCurrency && ctx.store.state.merchant.customAttributes.currency_symbol && intlCurrency !== ctx.store.state.merchant.customAttributes.currency_symbol) {
			currency = currency.replace(intlCurrency, ctx.store.state.merchant.customAttributes.currency_symbol)
		}

		return currency
	}

	const toCurrency = (price, currencyCode, color = 'black', size) => {
		let currency = ctx.i18n.n(
			price,
			{
				style: 'currency',
				currency: currencyCode || ctx.store.state.merchant.currencyCode,
				locale: ctx.store.state.locale
			}
		)

		const intlCurrency = getCurrencySymbol()

		if (intlCurrency && ctx.store.state.merchant.customAttributes.currency_symbol && intlCurrency !== ctx.store.state.merchant.customAttributes.currency_symbol) {
			currency = currency.replace(intlCurrency, ctx.store.state.merchant.customAttributes.currency_symbol)
		}

		if ((currencyCode === 'AED' && ctx.store.state.merchant.customAttributes.currency_symbol !== 'AED') || (!currencyCode && ctx.store.state.merchant.currencyCode === 'AED' && ctx.store.state.merchant.customAttributes.currency_symbol !== 'AED')) {
			const formatter = new Intl.NumberFormat(ctx.store.state.locale, {
				style: 'currency',
				currency: currencyCode || ctx.store.state.merchant.currencyCode
			})
			const parts = formatter.formatToParts(price)
			const numericOnly = parts
				.filter(p => ['integer', 'decimal', 'fraction'].includes(p.type))
				.map(p => p.value)
				.join('')

			return `
				<span style="display: inline-flex; align-items: baseline; gap: 2px;">
					${uaeDirham(color, size)}
					<span>${numericOnly}</span>
				</span>
			`
		} else if ((currencyCode === 'SAR' && ctx.store.state.merchant.customAttributes.currency_symbol !== 'SAR') || (!currencyCode && ctx.store.state.merchant.currencyCode === 'SAR' && ctx.store.state.merchant.customAttributes.currency_symbol !== 'SAR')) {
			const formatter = new Intl.NumberFormat(ctx.store.state.locale, {
				style: 'currency',
				currency: currencyCode || ctx.store.state.merchant.currencyCode
			})
			const parts = formatter.formatToParts(price)
			const numericOnly = parts
				.filter(p => ['integer', 'decimal', 'fraction'].includes(p.type))
				.map(p => p.value)
				.join('')

			return `
				<span style="display: inline-flex; align-items: baseline; gap: 2px;">
					${sarRiyal(color, size)}
					<span>${numericOnly}</span>
				</span>
			`
			}

		return currency
	}

	const getCurrencyDecimalPlaces = (currencyCode) => {
		const numberFormat = new Intl.NumberFormat(ctx.store.state.locale, {
			style: 'currency',
			currency: currencyCode || ctx.store.state.merchant.currencyCode
		}).resolvedOptions()

		return ctx.store.state.merchant.customAttributes?.decimal_places || numberFormat.maximumFractionDigits
	}

	const getDecimalPlaces = (currencyCode) => {
		const numberFormat = new Intl.NumberFormat(ctx.store.state.locale, {
			style: 'currency',
			currency: currencyCode || ctx.store.state.merchant.currencyCode
		}).resolvedOptions()

		return numberFormat.maximumFractionDigits
	}

	const getMinDecimalValue = (currencyCode) => {
		return 1 / Math.pow(10, getCurrencyDecimalPlaces(currencyCode))
	}

	const transformNumber = (value, currencyCode) => {
		return parseFloat((+value).toFixed(getCurrencyDecimalPlaces(currencyCode)))
	}

	const transformDecimalNumber = (value, currencyCode) => {
		return parseFloat((+value).toFixed(getDecimalPlaces(currencyCode)))
	}

	inject('currency', {
		getCurrencySymbol,
		currencySymbol,
		toCurrency,
		toCurrencyString,
		getCurrencyDecimalPlaces,
		getDecimalPlaces,
		getMinDecimalValue,
		transformNumber,
		transformDecimalNumber
	})
}
